/**
 * Formats a given bps (basis points) value by dividing it by 10,000.
 * If the input is null, it defaults the value to 0 before formatting.
 *
 * @param {number | null} bps - The bps value to be formatted. Can be null.
 * @returns {number} The formatted bps value as a number, representing the value divided by 10,000.
 */
export function formatBpsValue(bps: number | null) {
    const bpsValue = bps || 0;
    return bpsValue / 10000;
}
